import { TimeRange, unixTimestamp } from "types/common";
import { PaymentMethodType } from "@shared/types";

export type CreateReferralLinkRequest = {
  referral_code: string;
  description?: string;
};

export type EditReferralLinkRequest = {
  referral_id: number;
  description: string;
};

export type DeleteReferralLinkRequest = {
  referral_id: number;
};

export type CreatePayoutRequest = {
  amount: number;
  payout_method_id: number;
  payout_method_type: PaymentMethodType;
};

export type CancelPayoutRequest = {
  payout_id: number;
};

export interface ReferralLink {
  time: unixTimestamp;
  description: string;
  referral_code: string;
  paid_users: number;
  registered_users: number;
  commission: number;
  referral_id: number;
  clicks: number;
}

export interface CommissionHistory {
  time: unixTimestamp;
  customer_id: number;
  revenue: number;
  commission: number;
  commission_rate: number;
  status: CommissionStatus;
  referral_code: string;
  source?: ReferralType;
}

export enum CommissionStatus {
  PENDING = 1,
  APPROVED = 2,
  CANCELLED = 3,
  ZOMBIE = 4,
  PAYMENT_REFUNDED = 5,
}

export interface ReferredUser {
  time: unixTimestamp;
  costumer_id: number;
  revenue: number;
  commission: number;
  referral_code?: string;
  referral_codes: string;
  source: ReferralType;
  is_active?: boolean;
}

export enum ReferralType {
  CORNIX_POINTS = 1,
  PAYOUTS = 2,
  PROMO_CODE = 3,
}

export interface Payout {
  time: unixTimestamp;
  amount: number;
  payout_method: string;
  status: PayoutStatus;
  payout_id: number;
}

export enum PayoutStatus {
  PENDING = 1,
  APPROVED = 2,
  CANCELLED = 3,
  DENIED = 4,
}

export interface Tier {
  tier: number;
  bottom: number;
  top: number;
  commission_rate: number;
}

export interface GetReferralHistoryResponse {
  data: ReferredUser[];
  tiers: Tier[];
}
export type GetOrCreateCodeResponse = {
  referral_id: number;
  code: string;
};

export type GetReferredChartRequest = {
  time_range: TimeRange;
};

export type GetEarningsChartRequest = {
  year: number;
  month: number;
};
